<template>
  <span class="display-element form-section-description no-label" style="color: #8d8d8d">{{ value }}</span>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
  },
  setup() {},
};
</script>
